import { NextApiResponseBody } from 'types/bolt-api/request'
import { CreateComplaintCaseRequestBody, CreateComplaintCaseResponseBody } from '@boltenergy-be/shared'

export const postComplaint = async (
  body: CreateComplaintCaseRequestBody
): Promise<NextApiResponseBody<CreateComplaintCaseResponseBody>> => {
  try {
    const res = await fetch(`/api/cases/complaints`, {
      method: 'POST',
      body: JSON.stringify(body)
    })

    return (await res.json()) as NextApiResponseBody<CreateComplaintCaseResponseBody>
  } catch (error) {
    return { success: false }
  }
}
